export const ConsultationFormType = {
	Survey: 0,
	Probe: 1,
	PublicBudget: 2,
	Comment: 3,
	PostAddress: 4,
	EmailAddress: 5,
	Opinion: 6
};

export const ConsultationFormContainerType = {
	Voted: 0,
	Contact: 1
}

export const ConsultationFormStatus = {
	InProgress: 0,
	Active: 1,
	Close: 2,
	Withdraw: 3,
	Delete: 4
};

export const ProjectMode = {
	Open: 0,
	Close: 1,
	Citizen: 2,
	NotSetted: 255
};

export const ProjectStatus = {
	InProgress: 0,
	Active: 1,
	Close: 2,
	Archive: 3,
	Withdraw: 4
};

export const ProjectType = {
	NotSetted: 255,
	Consultation: 0,
	Survey: 1,
	Probe: 2,
	PublicBudget: 3,
	DirectMeeting: 4,
	CitizenInitiative: 5,
	ProjectTask: 6
};

export const QuestionType = {
	SingleRadio: 0,
	SingleCheck: 1,
	SingleText: 2,
	SingleDate: 3,
	MultipleCheck: 4,
	Ranking: 5,
	Matrix: 6,
	Budget: 7
};

export const AttachmentType = {
	Common: 0,
	Result: 1,
	Initiative: 2
};

export const AttachmentStatus = {
	InProgress: 0,
	Close: 1
};

export const PublishType = {
	Manual: 0,
	Automatic: 1,
	NotSetted: 255
};

export const CommentingMode = {
	Manual: 0,
	Automatic: 1,
	NotSetted: 255
};

export const VoteMode = {
	Complete: 0,
	Part: 1,
	NoVote: 2,
	NotSetted: 255
};

export const ThematicAreaDropdownOption = {
	NotSetted: -1
};

export const DefaultOffice = {
	NotSetted: -1
};

export const InitiativeMode = {
	Hidden: 0,
	Disabled: 1,
	Enabled: 2
};

export const DistrictDropdownOption = {
	NotSetted: -1
};

export const BudgetYearDropdownOption = {
	NotSetted: -1
};

export const BudgetPageType = {
	NotSetted: -1,
	Schedule: 0,
	Help: 1,
	Prerequisite: 2
};

export const BudgetStatus = {
	NotSetted: -1,
	Draft: 0,
	InProgress: 1,
	Published: 2,
	Finished: 3
};

export const ProjectTaskStatusDropdownOption = {
	NotSetted: -1
}

export const PageSize = {
	All: -1
}

export const InitiativeType = {
	NotSetted: -1,
	BudgetProject: 0,
	ConsultationProposal: 1,
	Other: 2,
	ConsultationComment: 3
}

export const ImageMimeType = {
	SVG: 'image/svg+xml',
	BMP: 'image/bmp',
	PNG: 'image/png',
	JPG: 'image/jpeg',
	GIF: 'image/gif'
}

export const ExpendActionType = {
	add: 'add',
	remove: 'remove'
}

export const SystemOffice = 1000000;
export const SystemDistrict = 1000000;

export const UserSex = {
	NotSetted: {
		value: -1,
		name: 'Wybierz...'
	},
	Male: {
		value: 0,
		name: 'Pan'
	},
	Female: {
		value: 1,
		name: 'Pani'
	}
};

export const StreetFeatureDropdownOption = {
	NotSetted: 0
}

export const LegalAge = 18;

export const AppLayoutElement = {
	unknown: -1,
	mainElement: 1,
	menuElementConsultation: 2,
	menuElementBudget: 3,
	menuElementSurvey: 4,
	menuElementProbe: 5,
	menuElementInitiative: 6,
	tileConsultation: 7,
	tileBudget: 8,
	tileSurvey: 9,
	tileInitiative: 10
};

export const ElementType = {
	Link: 0,
	EForm: 10
}

export const LinkTarget = {
	Blank: 0,
	Self: 10
}